import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import Body from './Body';
import Header from './Header';

Body.displayName = 'Application.Body';
Header.displayName = 'Application.Header';

/**
Il componente Application permette di definire un'applicazione composta da due parti:
un Header ed un corpo in cui l'header è fisso in cima alla pagina e scrolla solo il corpo.
All'interno del componente è poi possibile specificare i children desiderati.
 */
const Application = ({ children, className, ...others }) => (
  <div
    {...others} // eslint-disable-line react/jsx-props-no-spreading
    className={cns('application', className)}
  >
    {children}
  </div>
);

Application.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
};

Application.defaultProps = {
  children: null,
  className: '',
};

Application.Header = Header;
Application.Body = Body;

export default Application;
